<template id="Modele">
	<div :id="id" class="subpage_container">
		<h2>{{subtitle}}</h2>
		<div class="about second">
			<p v-html="description1"></p>
		</div>
		<div class="infos">
			<div class="documents">
				<div class="prix">
					<div>
					<span v-html="prix"></span><h3>(Prix en agence - à Sète et à Gigean)</h3>
					<p v-html="taxes"></p>
					</div>
					<div v-if="showGo()" class="go"><router-link :to="go_path"><p>Calculer le prix de ma carte grise / Effectuer cette démarche en ligne</p></router-link></div>
				</div>
				<div class="list_documents">
					<transition-group name="list" class="list_documents">
						<div class="document fade-in fade-out" v-for="(value, index) in this.documents" v-bind:key="(value, index)">
							<span class="material-icons md-30 md-light">{{icons[index]}}</span>
							<p>{{ value }}</p>
						</div>
					</transition-group>
				</div>
				<!--
				<div class="info_document">
					<router-view class="sub_nav fade-in fade-out"></router-view>
				</div>
				-->
			</div>
			<div class="cas_part">
				<button v-if="btns.length>0" @click="show_cas_particuliers(); isActive.includes('btn1') ? isActive.splice(isActive.indexOf('btn1'),1) : isActive.push('btn1','cas_particuliers')" :class="{closebtn: isActive.includes('btn1') }">{{isActive.includes('btn1') ? "X" : "Vous êtes dans un cas particulier ? Cliquez ici"}}</button>
				<div v-if="cas_particuliers" class="documents_param" >
					<button class="button_cas_part" v-for="btn in btns" @click="add_document(btn.remove,btn.add,btn.prix) ; isActive.includes(btn.id) ? isActive.splice(isActive.indexOf(btn.id),1) : isActive.push(btn.id)" :class="{active: isActive.includes(btn.id) }">{{btn.txt}}</button>
				</div>
			</div>
		</div>
		<p v-html="description2" class="about second"></p>

	<!--<router-clink to="/immatriculation/carte_grise/documents" href="#Immatriculation"><button>Voir les documents</button></router-link>-->
	</div>
</template>

<script>
const fb = require('../firebaseConfig.js')
import firebase from 'firebase'
export default {
	props:['id'],
	name: 'Modele',
	data () {
		return {
			subtitle:"",
			documents_list:[],
      		documents:[],
      		icons:[],
      		calcul_prix:[],
      		prix:"",
      		taxes:"",
      		description1:"",
      		description2:"",
      		cas_particuliers:false,
      		isActive:[],
      		btns:[],
      		go_path:""
		}
	},
	methods: {
		showGo(){
			if(this.$route.meta.go){
				this.go_path=this.$route.meta.go
				return true;
			}
		},
		show_cas_particuliers(){
			this.cas_particuliers = !this.cas_particuliers
		},
		active(event){
			event.target.classList.add("active")
		},
		add(indexs,prix){
			indexs.forEach(index => {
				if(this.documents_list.includes(index)){
					var doc = this.$store.state.static[this.id]
					var ind = this.documents_list.indexOf(index)
					this.documents.splice(ind,1)
					this.icons.splice(ind,1)
					this.documents_list.splice(ind,1)
					this.prix=doc.prix

				}else{
					var liste = this.$store.state.static.liste
					this.documents.push(liste[index].value)
					this.icons.push(liste[index].icon)
					this.documents_list.push(index)
					this.prix=prix
				}
			})
		},
		add_document(removes,indexs,prix){
			if(removes){
				removes.forEach(remove => {
					if(this.isActive.includes(remove)){
						this.isActive.splice(this.isActive.indexOf(remove),1)
						// console.log("remove : "+remove)
						// console.log("btns : "+this.btns)
						// console.log(this.btns[remove])
						var inds = []
						this.btns.forEach(btn => {
							if(btn.id == remove){
								inds = btn.add
							}
						})
						// console.log("inds"+inds)
						//var inds = this.documents_list.indexOf(this.btns[remove].add)
						this.add(inds,prix)
					}
				})
			}
			this.add(indexs,prix)
		},
		remove(removes){
			if(removes){
				removes.forEach(remove => {
					if(this.isActive.includes(remove)){

						this.isActive.splice(this.isActive.indexOf(remove),1)

						var doc = this.$store.state.static[this.id]
						var inds = this.documents_list.indexOf(this.btns.remove.add)
						inds.forEach(ind => {
							this.documents.splice(ind,1)
							this.icons.splice(ind,1)
							this.documents_list.splice(ind,1)
							this.prix=doc.prix
						})
					}
				})
			}
		}
	},
	mounted () {
		if(Object.keys(this.$store.state.static).length === 0){
			firebase.auth().signInAnonymously()
      .then(() => {
				// console.log("object empty")
				fb.db.collection('documents').doc(this.id).get()
  			.then(res => {
	  			this.subtitle=res.data().subtitle
	  			this.taxes=res.data().taxes
	  			this.prix=res.data().prix
	  			this.description1=res.data().description1
	  			this.description2=res.data().description2
	  			this.btns=res.data().btns
	  			this.packs=res.data().packs
	  			res.data().documents.forEach(x=>{
	  				this.documents_list.push(x)
	  			})
	  			fb.db.collection('documents').doc("liste").get()
					.then(res2 =>{
						this.documents_list.forEach(index => {
							this.documents.push(res2.data()[index].value)
							this.icons.push(res2.data()[index].icon)
						})
					})
		  	})
  		})
		}else{
			// console.log("object not very empty :/")
			var doc = this.$store.state.static[this.id]
			this.subtitle=doc.subtitle
			this.taxes=doc.taxes
			this.prix=doc.prix
			this.description1=doc.description1
			this.description2=doc.description2
			this.btns=doc.btns
			this.packs=doc.packs
			doc.documents.forEach(x=>{
				this.documents_list.push(x)
			})
			var liste = this.$store.state.static.liste
			this.documents_list.forEach(index => {
				this.documents.push(liste[index].value)
				this.icons.push(liste[index].icon)
			})
		}
  		
	},
	destroyed () {
			this.subtitle=""
			this.documents_list=[]
      		this.documents=[]
      		this.icons=[]
      		this.prix=""
      		this.taxes=""
      		this.description1=""
      		this.description2=""
      		this.cas_particuliers=false
      		this.isActive=[]
	}
}
</script>

<style scoped>
.list-enter-active, .list-leave-active {
  transition: all 1s;
}
.list-enter /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-30px);
}
.list-leave-to{
  opacity: 0;
  transform: translateX(30px);
}
.go{
	width: 100%;
	text-align:left;
	/*margin:30px 10px -55px 0px;*/
	margin:10px 0px -10px 0px;
	font-style: italic;
	text-decoration: underline;
	color:#22417B ;
	font-weight:500;
}
.go p{
	margin:0px;
	padding:0px;
	cursor: pointer;
}

@media all and (max-width: 1200px) {
.go{text-align:center;}
	}
</style>



// WEBPACK FOOTER //
// src/components/Modele.vue